import { API_BASE } from './config';

const KEY = 'dsw_admin_password';

export function isAuthed() {
  return !!localStorage.getItem(KEY);
}

export function getPassword() {
  return localStorage.getItem(KEY) || '';
}

export function logout() {
  localStorage.removeItem(KEY);
}

async function request(path, { method = 'GET', body, admin = false } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (admin) headers['x-admin-password'] = getPassword();

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    let msg = `Error ${res.status}`;
    try {
      msg = (await res.json()).error || msg;
    } catch {
      /* sin cuerpo JSON */
    }
    throw new Error(msg);
  }
  return res.status === 204 ? null : res.json();
}

export async function login(password) {
  await request('/login', { method: 'POST', body: { password } });
  localStorage.setItem(KEY, password);
}

export const listarPresupuestos = () => request('/presupuestos', { admin: true });

// Panel admin: obtiene un presupuesto por su código (DSW-XXXXXX) para editar.
// Desde la migración a .NET, este endpoint requiere el header x-admin-password.
export const obtenerPresupuesto = (codigo) =>
  request(`/presupuestos/${encodeURIComponent(codigo)}`, { admin: true });

// Acceso público del cliente: obtiene un presupuesto por su token (UUID).
// Es la credencial del link que se le envía al cliente (capability URL).
export const obtenerPresupuestoPublico = (token) =>
  request(`/presupuestos/p/${encodeURIComponent(token)}`);

export const crearPresupuesto = (data) =>
  request('/presupuestos', { method: 'POST', body: data, admin: true });

export const actualizarPresupuesto = (codigo, data) =>
  request(`/presupuestos/${encodeURIComponent(codigo)}`, {
    method: 'PUT',
    body: data,
    admin: true,
  });

export const eliminarPresupuesto = (codigo) =>
  request(`/presupuestos/${encodeURIComponent(codigo)}`, {
    method: 'DELETE',
    admin: true,
  });

// Firma pública del cliente: usa el token del link, no el código.
export const firmarPresupuesto = (token, nombre) =>
  request(`/presupuestos/p/${encodeURIComponent(token)}/firmar`, {
    method: 'POST',
    body: { nombre },
  });

export const cancelarPresupuesto = (codigo, motivo) =>
  request(`/presupuestos/${encodeURIComponent(codigo)}/cancelar`, {
    method: 'POST',
    body: { motivo },
    admin: true,
  });
